"use strict";
/**
 * This is not a production server yet!
 * This is only a minimal backend to get started.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const environment_ts_1 = require("../../service-lib/src/lib/environment.ts");
const common_bootstrap_1 = require("../../service-lib/src/lib/common-bootstrap");
const app_module_1 = require("./app/app.module");
async function bootstrap() {
    const commonBootstrap = new common_bootstrap_1.CommonBootstrap();
    const port = environment_ts_1.ENV.PORT_NOTIFICATION_SERVICE ? parseInt(environment_ts_1.ENV.PORT_NOTIFICATION_SERVICE, 10) : 3015;
    await commonBootstrap.bootstrap(port, app_module_1.AppModule, 'Notification Service');
}
bootstrap();
